import React from 'react';

import StreetViewSolidIcon from '../../shared/icons/street-view-solid-icon';

import './toggle.scss';

interface ToggleProps {
  ariaLabelledBy: string;
  icon?: React.ReactElement;
  isEnabled: boolean;
  label?: React.ReactElement;
  onToggle: () => void;
}

function Toggle(props: ToggleProps): React.ReactElement {
  const { ariaLabelledBy, icon, isEnabled, label, onToggle } = props;

  return (
    <label
      aria-labelledby={ariaLabelledBy}
      className="toggle"
      styleName="container"
    >
      <input onChange={onToggle} styleName="input" type="checkbox" />
      <div
        className={`toggle__indicator ${
          isEnabled ? 'toggle__indicator--checked' : ''
        }`}
        styleName={`indicator ${isEnabled ? 'indicator--checked' : ''}`}
      >
        <div className="toggle__circle" styleName="circle">
          {icon ?? <StreetViewSolidIcon />}
        </div>
      </div>
      {label}
    </label>
  );
}

export default Toggle;
